import { render } from "./DocumentationPersonPanel.vue?vue&type=template&id=726508b1&scoped=true"
import script from "./DocumentationPersonPanel.vue?vue&type=script&lang=js"
export * from "./DocumentationPersonPanel.vue?vue&type=script&lang=js"

import "./DocumentationPersonPanel.vue?vue&type=style&index=0&id=726508b1&scoped=true&lang=scss"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726508b1"]])

export default __exports__